export default "__VITE_ASSET__lJE4IljD__"